import { animate, style, transition, trigger } from '@angular/animations';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { FormControl, NgControl } from '@angular/forms';
import { isTrueLike, Utilities } from '@approot/utilities';
@Component({
  selector: 'input-with-spinner',
  templateUrl: './input-with-spinner.component.html',
  styleUrls: ['./input-with-spinner.component.scss'],
  animations: [
    trigger('incrementDecrement', [
      transition('* => increment', [
        style({ 'background-color': 'var(--value-increased)' }),
        animate('700ms ease-in')
      ]),
      transition('* => decrement', [
        style({ 'background-color': 'var(--value-decreased)' }),
        animate('700ms ease-in')
      ])
    ])
  ]
})
export class InputWithSpinnerComponent implements OnInit, AfterViewInit {
  @ViewChild('inputElem', { static: false }) public inputElem: ElementRef;
  @Input() public useBasicTextBox: boolean;
  @Input() public id: string;
  @Input() public className = '';
  @Input() public inputValidatorKey: string[];
  @Input() public required: boolean;
  @Input() public readOnly: boolean;
  @Input() public type = 'text';
  @Input() public formControlName: string;
  @Input() public placeholder = '';
  @Input() public info: string;
  @Input() public flashOnChange = false;
  @Input() public textColor: string;
  @Input() public showSpinner: boolean;
  @Input() public tabIndex: number | null;
  @Input() public title = '';
  @Output() public inputChange = new EventEmitter<string>();
  @Output() public onBlur = new EventEmitter<void>();
  @Output() public onFocus = new EventEmitter<void>();
  public flashClass = '';
  public formControl: FormControl;
  public widthOfInput: number;
  public changeSinceFocus = false;
  constructor(
    public ngControl: NgControl,
    private changeRef: ChangeDetectorRef
  ) {
    ngControl.valueAccessor = this;
  }

  public ngOnInit(): void {
    this.formControl = this.ngControl.control as FormControl;
    this.readOnly = isTrueLike(this.readOnly); // runtime value can be string or boolean :-(
  }

  public ngAfterViewInit(): void {
    setTimeout(() => {
      if (this.inputElem && this.inputElem.nativeElement)
        this.widthOfInput = this.inputElem.nativeElement.offsetWidth;
      this.changeRef.detectChanges();
    });
  }

  public onElemBlur(): void {
    setTimeout(_ => {
      this.changeSinceFocus = false;
    }, 10);
    this.onBlur.emit();
  }

  public onElemFocus(): void {
    this.onFocus.emit();
  }

  public writeValue(value: string | number): void {
    const isPending = this.formControl?.pending;
    const prevValue = this.inputElem?.nativeElement.value;
    const prevValueAsNum = Utilities.cleanFormattedNumeric(prevValue);
    const valueAsNum = Utilities.cleanFormattedNumeric(value);

    if (
      !isPending &&
      this.flashOnChange &&
      !this.changeSinceFocus &&
      Utilities.isNotBlank(prevValue) &&
      Utilities.isNotBlank(value) &&
      prevValueAsNum !== valueAsNum
    ) {
      this.flashClass = '';
      this.changeRef.detectChanges();
      setTimeout(() => {
        this.flashClass =
          valueAsNum > prevValueAsNum ? 'increment' : 'decrement';
        this.changeRef.detectChanges();
      }, 0);
    }
  }

  public onInput(event: Event): void {
    this.changeSinceFocus = true;
    this.inputChange.emit((event.target as any).value);
  }

  public registerOnChange(fn: any): void {}
  public registerOnTouched(fn: any): void {}
  public setDisabledState?(isDisabled: boolean): void {}
}
